export const LOGO_URL =
  "https://cdn.magicpatterns.com/uploads/2cFEzNMiSEa61Lhccen35m/hf_20261008_215731_687f4d79-65d8-475f-a3c9-e94d2f87371b.png";

export const MOTTO_LINES = [
  "El sueño inicia el camino,",
  "el sacrificio lo construye,",
  "la constancia lo sostiene,",
  "y el éxito, es el resultado.",
];

export const navLinks = [
  { label: "Nosotros", href: "#nosotros" },
  { label: "Servicios", href: "#servicios" },
  { label: "Enfoque", href: "#enfoque" },
  { label: "Contacto", href: "#contacto" },
];

export const whatsappNumbers = [
  { display: "+54 9 11 4179-7515", url: "https://wa.me/5491141797515" },
  { display: "+54 9 11 7366-0624", url: "https://wa.me/5491173660624" },
];

export const contactInfo = {
  email: "contactofortissm@gmail.com",
  transfermarktUrl: "https://www.transfermarkt.com.ar/fortis-sports-management/beraterfirma/berater/11344",
  instagramHandle: "@fortis.sm",
  instagramUrl: "https://www.instagram.com/fortis.sm/",
};

export const transfermarktProfile = {
  verifiedSince: "04/06/2024",
  featuredPlayers: [
    { name: "Carlos González", position: "Delantero centro", age: 33, contract: 2027, value: "900 mil €" },
    { name: "Juan Espínola", position: "Jugador profesional", age: 31, contract: 2026, value: "700 mil €" },
  ],
  remainingPlayers: 6,
};

export const coachServices = [
  {
    title: "Negociación de contratos",
    description: "Condiciones, duración y cláusulas acordes al proyecto deportivo y a la trayectoria del técnico.",
  },
  {
    title: "Búsqueda de proyectos",
    description:
      "Identificamos clubes y ligas, nacionales e internacionales, donde la idea de juego del entrenador pueda crecer.",
  },
  {
    title: "Planificación de carrera",
    description: "Objetivos claros para cada etapa, desde categorías formativas hasta primeros equipos.",
  },
  {
    title: "Perfil profesional",
    description: "Presentamos la metodología y la trayectoria del técnico ante dirigentes y clubes de forma sólida.",
  },
];

export const services = [
  {
    id: "transferencias",
    title: "Transferencias nacionales e internacionales",
    description:
      "Concretamos traspasos dentro y fuera del país, gestionando cada detalle de la operación de principio a fin.",
  },
  {
    id: "clubes",
    title: "Oportunidades en clubes",
    description:
      "Conseguimos oportunidades reales en clubes, buscando el proyecto deportivo adecuado para cada jugador.",
  },
  {
    id: "contratos",
    title: "Negociación de contratos",
    description:
      "Defendemos el valor del jugador en cada negociación: condiciones, cláusulas y plazos pensados para su crecimiento.",
  },
  {
    id: "bienestar",
    title: "Gestión médica y bienestar",
    description:
      "Coordinamos especialistas, seguimiento físico y apoyo integral para que el jugador rinda y se cuide.",
  },
  {
    id: "carrera",
    title: "Planificación de carrera",
    description:
      "Trazamos un recorrido a largo plazo, evaluando cada oportunidad según la etapa y los objetivos del jugador.",
  },
  {
    id: "imagen",
    title: "Imagen y comunicación",
    description:
      "Construimos una imagen profesional coherente, al servicio de la carrera y no al revés.",
  },
];

export const pillars = [
  {
    title: "Confianza",
    description:
      "Relaciones claras y transparentes: el jugador y su familia saben siempre qué hacemos y por qué.",
  },
  {
    title: "Estrategia",
    description:
      "Decisiones con propósito. Cada paso se evalúa pensando en la carrera completa, no solo en el próximo contrato.",
  },
  {
    title: "Compromiso",
    description:
      "Presencia en cada etapa: en los buenos momentos, en las lesiones y en las decisiones difíciles.",
  },
];

export const profileOptions = [
  "Jugador",
  "Familia / Tutor",
  "Entrenador",
  "Club",
  "Otro",
];
